import _ from 'lodash';

export default {
    namespaced: true,
    state: {
        isLoading: false,
        updatedAnalyticsData: {},
        originalData: {},
        attribute: ""
    },
    getters: {
        isLoading: (state) => {
            state.isLoading
        }
    },
    mutations: {
        updateAnalyticsData: (state, payload) => {
            state.updatedAnalyticsData = payload
        },
        setOriginalData: (state, payload) => {
            state.originalData = payload
        },
        setIsLoading: (state, payload) => {
            state.isLoading = payload
        },
        setAttribute: (state, payload) => {
            state.attribute = payload
        }
    },
    actions: {
        async updateAnalyticsData ( { commit, rootState, state }, payload) {
            commit('setIsLoading', true)
            try {
                const analyticsData = _.cloneDeep(rootState.Analytics.analyticsData)
                if (payload.attribute !== state.attribute) {
                    commit('setOriginalData', _.cloneDeep(analyticsData))
                    commit('setAttribute', payload.attribute)
                }

                const originalData = _.cloneDeep(state.originalData)

                const graphTableData = originalData.graphs.filter( (item) =>
                { return item.type === 'table'}).shift()
                const tableIndex = originalData.graphs.findIndex( (item) =>
                { return item.type === 'table' })

                // Filter the data
                const filterDataObject = (data, filter) => {
                    for (let key in data) {
                        data[key] = data[key].filter((item) => {
                            return item.year === filter.year && item.duration === filter.duration
                        });
                    }
                    return data
                };
                const filteredTableData = filterDataObject(graphTableData.data.data, payload.data);

                // Filter the header
                const filterTableHeader = (data, filter) => {
                    let items = data.filter( (item) => {
                        return item === filter.duration
                    })
                    return [ ...new Set(items) ];
                }

                // Update the data
                const filteredTableHeader = filterTableHeader(graphTableData.data.headers, payload.data)

                analyticsData.graphs[tableIndex].data.data = filteredTableData
                analyticsData.graphs[tableIndex].data.headers = filteredTableHeader

                commit('Analytics/setIsLoading', true, { root: true })
                commit('Analytics/setAnalyticsData', analyticsData, { root: true })
                commit('Analytics/setIsLoading', false, { root: true })

            } catch (error) {
                console.warn(error)
            }

            commit('setIsLoading', false)
        }
    }
}
